import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { FlexLayoutModule } from "@angular/flex-layout";
import { AutoCompleteModule } from "@bfx/primeng/autocomplete";
import { ButtonModule } from "@bfx/primeng/button";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { DialogModule } from "@bfx/primeng/dialog";
import { InputTextareaModule } from "@bfx/primeng/inputtextarea";
import { OverlayPanelModule } from "@bfx/primeng/overlaypanel";
import { TranslateModule } from "@ngx-translate/core";

import { BfxDialogsContainerComponent } from "./bfx-dialogs-container.component";
import { BfxDialogOrderQuickFillConfirmComponent } from "./bfx-dialog-order-quick-fill-confirm.component";
import { BfxDialogOrderQuickFillWarningComponent } from "./bfx-dialog-order-quick-fill-warning.component";
import { BfxDialogOrderDetailFillWarningComponent } from "./bfx-dialog-order-detail-fill-warning.component";
import { BfxDialogOrderAcceptIntoComponent } from "./bfx-dialog-order-accept-into.component";
import { BfxDialogOrderCancelWarningComponent } from "./bfx-dialog-order-cancel-warning.component";
import { BfxDialogOrderCancelConfirmComponent } from "./bfx-dialog-order-cancel-confirm.component";
import { BfxDialogTradeCancelConfirmComponent } from "./bfx-dialog-trade-cancel-confirm.component";
import { BfxDialogTradeAddFillCommentComponent } from "./bfx-dialog-trade-add-fill-comment.component";
import { BfxDialogExportComponent } from "./bfx-dialog-export.component";
import { BfxDialogFilterCopyComponent } from "./bfx-dialog-filter-copy.component";
import { BfxDialogFilterNewComponent } from "./bfx-dialog-filter-new.component";
import { BfxDialogFilterDeleteComponent } from "./bfx-dialog-filter-delete.component";
import { BfxDialogOpsIntClearConfirmComponent } from "./bfx-dialog-ops-int-clear-confirm.component";
import { BfxDialogConfirmComponent } from "./bfx-dialog-confirm.component";
import { BfxDialogOKComponent } from "./bfx-dialog-ok.component";
import { BfxDialogOKCancelComponent } from "./bfx-dialog-ok-cancel.component";
import { BfxDialogsCoordinatorService } from "./services/bfx-dialogs-coordinator.service";
import { BfxDialogsProcessorService } from "./services/bfx-dialogs-processor.service";
import { BfxOrderDialogsProcessorService } from "./services/bfx-order-dialogs-processor.service";
import { BfxTradeDialogsProcessorService } from "./services/bfx-trade-dialogs-processor.service";
import { BfxOpsIntDialogsProcessorService } from "./services/bfx-ops-int-dialogs-processor.service";
import { BfxElementsLibraryModule } from "app/bfx-element-library/bfx-elements-library.module";
import { BfxDialogFindNewFavoriteComponent } from "./bfx-dialog-find-new-favorite.component";
import { DraggableDialog } from "./directives/draggable-dialog.directive";
import { BfxDialogToleranceComponent } from "./bfx-dialog-tolerance.component";
import { BfxDialogRestartComponent } from "./bfx-dialog-restart.component";
import { BfxDialogReconnectComponent } from "./bfx-dialog-reconnect.component";
import { BfxDialogPublicProfileSaveComponent } from "./bfx-dialog-public-profile-save.component";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { BfxDialogFwdRollReplaceComponent } from "app/bfx-dialogs/bfx-dialog-fwd-roll-replace";
import { BfxAutoHedgeStatusChangeComponent } from "./bfx-dialog-auto-hedge-status-change.component";
import { BfxChangePasswordComponent } from "app/bfx-auth/bfx-change-password.component";
import { BfxDialogChangePasswordComponent } from "app/bfx-dialogs/bfx-dialog-change-password";
import { BaseComponentsModule } from "shared/base-components/base-components.module";
import { RadioButtonModule } from "@bfx/primeng/radiobutton";
import { BfxInterfaceControlsModule } from "app/bfx-interface-controls/bfx-interface-controls.module";
import { BfxDialogSwitchProfileComponent } from "app/bfx-dialogs/bfx-dialog-switch-profile.component";

@NgModule({
  declarations: [
    BfxDialogsContainerComponent,
    BfxDialogExportComponent,
    // Order
    BfxDialogOrderQuickFillConfirmComponent,
    BfxDialogOrderQuickFillWarningComponent,
    BfxDialogOrderDetailFillWarningComponent,
    BfxDialogOrderAcceptIntoComponent,
    BfxDialogOrderCancelWarningComponent,
    BfxDialogOrderCancelConfirmComponent,
    // Trade
    BfxDialogTradeCancelConfirmComponent,
    BfxDialogTradeAddFillCommentComponent,
    // Find
    BfxDialogFindNewFavoriteComponent,
    //Filter
    BfxDialogFilterCopyComponent,
    BfxDialogFilterNewComponent,
    BfxDialogFilterDeleteComponent,
    // ops-int
    BfxDialogOpsIntClearConfirmComponent,
    //public profile
    BfxDialogPublicProfileSaveComponent,
    BfxDialogReconnectComponent,
    // Restart / Login
    BfxDialogRestartComponent,
    // Generic
    BfxDialogConfirmComponent,
    BfxDialogOKComponent,
    BfxDialogOKCancelComponent,
    BfxDialogToleranceComponent,
    // Dealer Intervention
    BfxDialogFwdRollReplaceComponent,
    // directive
    DraggableDialog,
    BfxAutoHedgeStatusChangeComponent,
    BfxDialogChangePasswordComponent,
    BfxDialogSwitchProfileComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    FlexLayoutModule,
    BfxElementsLibraryModule,
    // prime-ng
    AutoCompleteModule,
    CheckboxModule,
    DialogModule,
    ButtonModule,
    OverlayPanelModule,
    InputTextareaModule,
    NativeDesktopModule,
    BaseComponentsModule,
    RadioButtonModule,
    BfxInterfaceControlsModule,
  ],
  providers: [
    BfxDialogsCoordinatorService,
    BfxDialogsProcessorService,
    BfxOrderDialogsProcessorService,
    BfxTradeDialogsProcessorService,
    BfxOpsIntDialogsProcessorService,
  ],
  exports: [
    BfxDialogsContainerComponent,
    BfxDialogExportComponent,
    // Order
    BfxDialogOrderQuickFillConfirmComponent,
    BfxDialogOrderQuickFillWarningComponent,
    BfxDialogOrderDetailFillWarningComponent,
    BfxDialogOrderAcceptIntoComponent,
    BfxDialogOrderCancelWarningComponent,
    BfxDialogOrderCancelConfirmComponent,
    // Trade
    BfxDialogTradeCancelConfirmComponent,
    BfxDialogTradeAddFillCommentComponent,
    //Filter
    BfxDialogFilterCopyComponent,
    BfxDialogFilterNewComponent,
    BfxDialogFilterDeleteComponent,
    BfxDialogReconnectComponent,
    //ops int
    BfxDialogOpsIntClearConfirmComponent,
    // Restart / Login
    BfxDialogRestartComponent,
    // Dealer Intervention
    BfxDialogFwdRollReplaceComponent,
    // Generic
    BfxDialogConfirmComponent,
    BfxDialogOKComponent,
    BfxDialogOKCancelComponent,
    BfxDialogToleranceComponent,
    //Public profile
    BfxDialogPublicProfileSaveComponent,
    DraggableDialog,
    BfxAutoHedgeStatusChangeComponent,
    BfxDialogChangePasswordComponent,
    BfxDialogSwitchProfileComponent,
  ],
  bootstrap: [BfxDialogsContainerComponent],
})
export class BfxDialogsModule {}
